module.exports = __webpack_public_path__ + "img/9-1.ec806016.jpg";